// extracted by mini-css-extract-plugin
module.exports = {"btn":"k_pq"};